import { jwtDecode } from "jwt-decode";
import React, { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
const navigate = useNavigate(); // inside your component
const REACT_APP_MASTER = process.env.REACT_APP_MASTER;

  useEffect(() => {
    const token = sessionStorage.getItem('accessToken');
    if (token) {
      setIsAuthenticated(true);
    }
    setIsLoading(false);
  }, []);
 
    const decodeAndStoreTokenData = (token) => {
    try {
      const decoded = jwtDecode(token);
      sessionStorage.setItem("accessToken", token);
      sessionStorage.setItem("user_id", decoded.user_id);
      sessionStorage.setItem("username", decoded.username);
      sessionStorage.setItem("email", decoded.email);
      sessionStorage.setItem(
        "permissions",
        JSON.stringify(decoded.permissions || [])
      );
      sessionStorage.setItem("roles", JSON.stringify(decoded.roles || []));
      sessionStorage.setItem("module", JSON.stringify(decoded.module || []));
      sessionStorage.setItem("employee_id", decoded.employee_id);
      sessionStorage.setItem("admin_unit", decoded.admin_unit);
      sessionStorage.setItem("org_unit", decoded.org_unit);
      sessionStorage.setItem("user_type", decoded.user_type);
      sessionStorage.setItem("is_superuser", decoded.is_superuser);
      sessionStorage.setItem("full_name", decoded.full_name);

      sessionStorage.setItem("detail", JSON.stringify(decoded));

      return true;
    } catch (error) {
      console.error("Error decoding token:", error);
      setError("Invalid token received");
      return false;
    }
  };

  const login = (token) => {
    if (decodeAndStoreTokenData(token)) {
      setIsAuthenticated(true);
      setIsLoading(false);
    } else {
      setIsLoading(false);
    }
  };

  const logout = () => {
    setIsAuthenticated(false);
    sessionStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decoded.exp < currentTime) {
          sessionStorage.clear();
          setIsAuthenticated(false);
        } else {
          setIsAuthenticated(true);
        }
      } catch (error) {
        sessionStorage.clear();
        setIsAuthenticated(false);
      }
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    function handleMessage(event) {
      if (event.data?.type === "SET_TOKEN") {
        const token = event.data.token;
        if (token && token !== sessionStorage.getItem("accessToken")) {
          console.log("[AuthContext] New token received, logging in");
          login(token);
        }
      }
    }
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  useEffect(() => {
  function handleMessage(event) {
    if (event.data?.type === "LOGOUT") {
      console.log("[Child] LOGOUT received from parent");
      sessionStorage.clear();        
      navigate("/");                  
    }
  }

  window.addEventListener("message", handleMessage);
  return () => window.removeEventListener("message", handleMessage);
}, [navigate]);

  // added for the master app purpose

  return (
    <AuthContext.Provider 
      value={{ 
        isAuthenticated, 
        isLoading,
        setIsAuthenticated,
        setIsLoading, 
        login,
        logout,
        error,
        setError
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  return useContext(AuthContext);
};